import { ConfigProvider, Flex, Tabs } from "antd";
import { useState } from "react";

import cx from "classnames";
import { createUseStyles } from 'react-jss';


const MyTabsMenu = ({ menuList = [], padding = '12px 16px', className = "", onChange = () => { }, isCard = false, defalut = null, backgroundColor = '#2151b6', color = 'white' }) => {
  const [selectedKeys, setSelectedKeys] = useState(defalut);

  const onMenuClick = (e) => {
    const key = e;
    setSelectedKeys(key);
    onChange(key);
    // storage.sessionStorage.setItem("config.menu", key);
  };


  const useStyles2 = createUseStyles({
    tab: {
      '& .ant-tabs-tab': {
        textAlign: 'center',
        padding: padding,
        borderRadius: '10rem',
        // margin: '5px',
        fontWeight: 'bold', // Applied to all .ant-tabs .ant-tabs-tab
        background: 'transparent', // Applied to all .ant-tabs .ant-tabs-tab
      },
      '& .ant-tabs-tab.ant-tabs-tab-active': {
        fontWeight: 'bold',
        color: 'white !important',
        background: `${backgroundColor} !important`,
        margin: '5px',
      },
      '& .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-left::before': {
        opacity: '0 !important',
      },
      '& .ant-tabs-nav': {
        margin: '0',
      },
      '& .ant-tabs-nav::before': {
        display: 'none !important',
      },

    },
  });

  const classes = useStyles2();

  return (

    <ConfigProvider theme={{
      components: {
        Tabs: {
          itemHoverColor: "var(--tab-color)",
          itemActiveColor: "var(--tab-color)"
        },
      },
    }}>
      <Tabs type={!isCard ? 'line' : "card"}
        // className={cx(classes.tab)} style={{
        //   backgroundColor: 'white',
        //   borderRadius: '10rem',
        // }}
        onChange={onMenuClick} items={menuList?.filter(o => o.key != null)?.map((entity) => {
          return {
            ...entity,
            label: <Flex gap={5} style={{
            }}>{entity.icons} {entity.label}
            </Flex>
          };
        })}>
      </Tabs>
    </ConfigProvider>
  );
};

export default MyTabsMenu;
